import { BusinessObjectBase } from './base';
import type { Candidate } from './candidate';

export interface EventAvailabilityData {
  readonly id: number;
  readonly hasMedicalConditions?: string;
  readonly medicalConditionDetails?: string;
  readonly disability?: string;
  readonly dataConsentToThirdParty?: string;
  readonly uniformSize?: string;
  readonly hasCriminalConvictions?: string;
  readonly candidateId: number;
  readonly candidate?: Candidate;
}

export interface EventAvailability extends Readonly<EventAvailabilityData> {}
export class EventAvailability extends BusinessObjectBase {
  static readonly entityName = 'EventAvailability' as const;
  static readonly plural = 'event-availabilities';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<EventAvailability[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new EventAvailability(data));
  }

  static async findOne(filter?: any): Promise<EventAvailability | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new EventAvailability(data) : null;
  }

  static async findById(id: number, filter?: any): Promise<EventAvailability> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new EventAvailability(data);
  }

  static async create(
    data: Omit<EventAvailabilityData, 'id'>,
  ): Promise<EventAvailability> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new EventAvailability(result);
  }

  static async updateById(
    id: number,
    data: Partial<EventAvailabilityData>,
  ): Promise<EventAvailability> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new EventAvailability(result);
  }

  static async deleteById(id: number): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
